import { defineStore } from 'pinia'
import { STORE_ID } from '../constants'
import type { Template } from '../entities/Template'

export const useTemplateStore = defineStore(STORE_ID, {
  state: (): Template => ({
    header: {
      showMenu: true,
      showShare: false,
      showPopover: false,
      showMenuPrivate: false,
      showPublicMenu: false,
    },
  }),
  getters: {},
  actions: {
    setTemplate(template: Template) {
      this.header.showMenu = template.header.showMenu
      this.header.showShare = template.header.showShare
      this.header.showPopover = template.header.showPopover
      this.header.showMenuPrivate = template.header.showMenuPrivate
      this.header.showPublicMenu = template.header.showPublicMenu
    },
    setHeaderShowPopover(value: boolean | undefined) {
      this.header.showPopover = value || false
    },
  },
})
